import { ClosingScheme, CriticalDateType } from '../models/critical-dates.models';
import { CLOSING_SCHEME_LABELS } from '@zayan-erp/home-building';

export interface CriticalDateRowLabels {
  firstTentative: string;
  secondTentative: string;
  firm: string;
  delayed: string;
  buyerTermination: string;
}

const FREEHOLD_ROW_LABELS: CriticalDateRowLabels = {
  firstTentative: '1st Tentative Closing',
  secondTentative: '2nd Tentative Closing',
  firm: 'Firm Closing',
  delayed: 'Delayed / Outside Closing',
  buyerTermination: 'Buyer Termination'
};

const POTL_ROW_LABELS: CriticalDateRowLabels = {
  firstTentative: '1st Tentative Occupancy',
  secondTentative: '2nd Tentative Occupancy',
  firm: 'Firm Occupancy',
  delayed: 'Delayed / Outside Occupancy',
  buyerTermination: 'Buyer Termination'
};

const CONDO_ROW_LABELS: CriticalDateRowLabels = {
  firstTentative: '1st Tentative Occupancy',
  secondTentative: 'Tentative Occupancy',
  firm: 'Firm Occupancy',
  delayed: 'Delayed / Outside Occupancy',
  buyerTermination: 'Buyer Termination'
};

export const CRITICAL_DATE_ROW_LABELS: Record<ClosingScheme, CriticalDateRowLabels> = {
  [ClosingScheme.Freehold]: FREEHOLD_ROW_LABELS,
  [ClosingScheme.Potl]: POTL_ROW_LABELS,
  [ClosingScheme.Condominium]: CONDO_ROW_LABELS
};

export const CRITICAL_DATE_TYPE_LABELS: Record<CriticalDateType, string> = {
  [CriticalDateType.FirstTentative]: 'First Tentative',
  [CriticalDateType.SecondTentative]: 'Second Tentative',
  [CriticalDateType.Firm]: 'Firm',
  [CriticalDateType.Delayed]: 'Delayed',
  [CriticalDateType.SubsequentTentative]: 'Subsequent Tentative',
  [CriticalDateType.FinalTentative]: 'Final Tentative',
  [CriticalDateType.Outside]: 'Outside'
};

export const NOT_COMPUTED_LABEL = 'not computed';
export const TARION_120_DAY_WARNING = "Exceeds Tarion's 120-day limit, requires purchaser agreement.";

export function closingSchemeLabel(scheme: ClosingScheme | number | null | undefined): string {
  if (scheme === ClosingScheme.Freehold || scheme === ClosingScheme.Potl || scheme === ClosingScheme.Condominium) {
    return CLOSING_SCHEME_LABELS[scheme];
  }
  return 'Not selected';
}

export function isClosingScheme(value: number | null | undefined): value is ClosingScheme {
  return value === ClosingScheme.Freehold || value === ClosingScheme.Potl || value === ClosingScheme.Condominium;
}

export function condoSubsequentTentativeLabel(subsequentAddendumCount: number, isFinalTentative: boolean): string {
  if (isFinalTentative) {
    return 'Final Tentative Occupancy';
  }
  const n = Math.max(subsequentAddendumCount + 1, 2);
  return `Tentative Occupancy #${n}`;
}
